import {FC} from 'react'
import ChekinListApp from '../components/ChekinListApp'

const HeaderCheckinAppPanel: FC = () => {
  return (
    <>
      <ChekinListApp />
    </>
  )
}

export {HeaderCheckinAppPanel}
